import { useId } from 'react';

import { Text } from '@betterment/samba-react';
import { css } from '@betterment/samba-styled-system/css';

import { FooterLink } from './FooterLink';

import { trackClick } from '../../../../features/track';
import brochureUrl from '../../../brochureUrl';
import { SUPPORT_EMAIL } from '../../../constants';

export const NonAdvisedLinks: React.FC = () => {
  const footerNavLabel = useId();

  return (
    <nav
      aria-labelledby={footerNavLabel}
      className={css({
        display: 'flex',
        paddingTop: 'space.400',
        paddingBottom: 'space.400',
        justifyContent: 'start',
        alignItems: 'baseline',
      })}
    >
      <Text as="span" color="text.weak" css={{ paddingRight: 'space.200', fontWeight: 'medium' }} id={footerNavLabel}>
        Questions?
      </Text>
      <ul className={css({ display: 'flex', gap: 'space.200', listStyleType: 'none', margin: '0', padding: '0' })}>
        <li>
          <FooterLink onClick={() => trackClick({ name: 'FAQ' })} target="_blank" href={brochureUrl('/help')}>
            Support Center
          </FooterLink>
        </li>
        <li>
          <FooterLink onClick={() => trackClick({ name: 'ContactUs' })} target="_blank" href={brochureUrl('/contact')}>
            Contact Us
          </FooterLink>
        </li>
        <li>
          <FooterLink href={`mailto:${SUPPORT_EMAIL}`}>Email Us</FooterLink>
        </li>
      </ul>
    </nav>
  );
};
